<script lang="ts">
	import { cn } from '$lib/utils';

	let className: string = '';
	export let id: string | null = null;
	export { className as class };
</script>

<div
	class={cn(
		'mx-auto flex h-auto w-full max-w-[1200px] scroll-mt-16 flex-col items-center justify-center px-8 py-16',
		className
	)}
	{id}
>
	<slot />
</div>
